export default "__VITE_ASSET__Bocas3vZ__ 100w";